import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as bookablePackageRateService from '../services/bookablePackageRateService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { setListBookablePackageRates, setSyncOneBookablePackageRate, setSyncBookablePackageRates, setBookablePackageRateDetail, getBookablePackageRateDetail, setListAllBookablePackageRates } from '../actions/bookablePackageRateAction';
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { bookablePackageRateAutoTranslateRequest } from 'actions/autoTranslateAction';

function* setListBookablePackageRateSaga() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(bookablePackageRateService.getBookablePackageRateList, action.hotelId, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListBookablePackageRates(result.data));
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function* syncBookablePackageRates() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATES_SYNC_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(bookablePackageRateService.syncBookablePackageRatesAll, action.hotelId);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put (setSyncBookablePackageRates(result));
        if(action.isRefresh && result.status === 200) {
            yield put({ type: Types.BOOKABLE_PACKAGE_RATE_ACTION, hotelId: action.hotelId, filters: { hotelId: action.hotelId } })
        }
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function* syncBookablePackageRate() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_SYNC_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(bookablePackageRateService.syncBookablePackageRate, action.id);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put (setSyncOneBookablePackageRate(result));
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function* getBookablePackageRateDetailData() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(bookablePackageRateService.getBookablePackageRateDetail, action.id);
        yield put(setBookablePackageRateDetail(result));
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function* updateBookablePackageRate() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        yield call(bookablePackageRateService.updateBookablePackageRate, action.data, action.id);
        if (action.data.targetLanguage && action.data.targetLanguage.length > 0) {
            yield put(bookablePackageRateAutoTranslateRequest({
                sourceId: action?.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.data?.targetLanguage,
                callbacks: action?.callbacks
            }));
        } else {
            Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
            if (action.callbacks?.onSuccess) {
                yield action.callbacks.onSuccess();
            }
            yield put(getBookablePackageRateDetail(action.id));
        }
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function* sortBookablePackageRate() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_SORT_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        yield call(bookablePackageRateService.sortBookablePackageRate, action.data);
        yield put({ type: Types.BOOKABLE_PACKAGE_RATE_ACTION, hotelId: action.hotelId, filters: { hotelId: action.hotelId } })
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

function errorHandleRate(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'rate');
}

function* getListAllBookablePackageRateSaga() {
    yield takeLatest(Types.BOOKABLE_PACKAGE_RATE_ALL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(bookablePackageRateService.getAllBookablePackageRateList, action.hotelId);
        yield put(setListAllBookablePackageRates(result?.bookablePackageRates || []));
    }, errorHandleRate(Types.BOOKABLE_PACKAGE_RATE_FAIL)))
}

export function* bookablePackageRateSaga() {
    yield all([
        fork(setListBookablePackageRateSaga),
        fork(syncBookablePackageRates),
        fork(syncBookablePackageRate),
        fork(getBookablePackageRateDetailData),
        fork(updateBookablePackageRate),
        fork(sortBookablePackageRate),
        fork(getListAllBookablePackageRateSaga),
    ])
}
